
import * as React from 'react';
import styled from 'styled-components';
import * as Highcharts from 'highcharts';
import * as _ from "lodash/fp";

import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';
import { Event } from '@process-advisor/process-miner/api/events';
import { Dropdown } from '@process-advisor/process-miner/components/shared/dropdown';
import { Section } from '@process-advisor/process-miner/components/shared/section';
import { SingleBlock } from '@process-advisor/process-miner/components/layout/singleBlock';
import { HighChart } from '@process-advisor/process-miner/components/charts/highChart/highChart';
import { Button } from '@process-advisor/process-miner/components/shared/button';

export type Data = []

const Wrapper = styled.div`
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    margin-bottom: 5px;
`;
let attribute = '';

let optionsAttributes = [];

const optionsChartType = [
    { value: 1, label: 'Bar' },
    { value: 2, label: 'Column' },
];


let chartType = 1

export const EventAttributes: React.FC = () => {
    const [data, setData] = React.useState<Data[]>([]);
    const [fullData, setFullData] = React.useState<Data[]>([]);
    const initialSize = 100;
    const [size, setSize] = React.useState(initialSize);
    const [chartTypeStr, setChartTypeStr] = React.useState('bar');
    const [metric, setMetric] = React.useState<string>('events');
    const [title, setTitle] = React.useState<string>('Events Created');
    const [label, setLabel] = React.useState<string>('Events');

    const optionsMetrics = [
        { value: 'events', label: 'Events' },
    ];
    

    React.useEffect(() => {
        setMetric('events');
        eventAttributes();
        const listener = () => {
            setFullData(apiProvider.analyticsEventAttributes({metric: metric}));
        };
        listener();
        apiProvider.on(Event.updateEvents, listener);

        return () => {
            apiProvider.off(Event.updateEvents, listener);
        };
    }, []);

    React.useEffect(() => {
        const listener = () =>
            eventAttributes();
        listener();
        apiProvider.on(Event.updateEvents, listener);
        apiProvider.on(Event.applyFilter, listener);
        apiProvider.on(Event.resetFilter, listener);

        return () => {
            apiProvider.off(Event.updateEvents, listener);
            apiProvider.off(Event.applyFilter, listener);
            apiProvider.off(Event.resetFilter, listener);
        };
    }, []);

    const onAttributeChange = (attributeSelected: string) => {
        attribute = attributeSelected;
        apiProvider.changeAnalyticsEventAttribute({ attribute });
        setFullData(apiProvider.analyticsEventAttributes({metric: metric}));
    };

    const eventAttributes = () => {
        optionsAttributes = [];
        const tOptions = apiProvider.eventAttributes({});
        for (const each of tOptions) {
            const valueToPush = { value: each.value, label: each.label };
            optionsAttributes.push(valueToPush);
        }
        if (optionsAttributes.length > 0 ) {
            attribute = optionsAttributes[0].value;
        }
    };

    const onMetricChange = (metric: string) => {
        setMetric(metric);
        if (metric === 'events') {setTitle('Events Created'); setLabel('Events')}
        setFullData(apiProvider.analyticsEventAttributes({metric: metric}));
    };

    const onChartTypeChange = (chartTypeSelected: number) => {
        chartType = chartTypeSelected 
        if (chartTypeSelected == 1) { setChartTypeStr('bar'); }
        if (chartTypeSelected == 2) { setChartTypeStr('column')}
    };


    React.useEffect(() => {
        setData(_.flowRight(_.reverse, _.sortBy((obj) => obj[1]))(fullData).slice(0, size));
    }, [fullData, size]);

    const options: Highcharts.Options = {
        chart: {
            //           renderTo: 'container',
            type: chartTypeStr,
            style: {
                fontFamily: 'system-ui'

            },
            borderWidth: 2,
            borderColor: '#E0E0E0'
           
        },
        title: {
            text: title,
            style: {
                fontSize: '14px',
                fontWeight: 'bold',
            },
        },
        xAxis: {
            type: 'category',
            title: {
                text: null,
            },
            min: 0,
            max: Math.min(data.length - 1, 20),
            scrollbar: {
                enabled: true,
            },
            tickLength: 0,
        },
        yAxis: {
            title: {
                text: '',
            },
        },
        legend: {
            enabled: false,
        },
        plotOptions: {
            series: {
                dataLabels: {
                    enabled: true,
                    formatter () {
                        if (metric == 'events') {
                            return Highcharts.numberFormat(this.y, null, null, ',');
                        } 
                        if (metric == 'perc_automation' ) {
                            return this.y.toFixed(1) +'%'
                        }
                    },
                    style: {
                        fontWeight: 'normal',
                    },
                },
            },
        },
        credits: {
            enabled: false,
        },
        series: [
            {
                type: 'column',
                color: '#0B66E4',
                dataSorting: {
                    enabled: true,
                    sortKey: 'y',
                },
                data,
                name: label,
            },
        ],
    };

    return (
        <Wrapper>
            <SingleBlock width="10%">
                <Section title='Group by:'/>
            </SingleBlock>
            <SingleBlock width="20%">
                <Dropdown
                    options={optionsAttributes}
                    onChange={onAttributeChange}
                    value={attribute}/>
            </SingleBlock>
            <SingleBlock width="10%">
                <Section title='Metric:'/>
            </SingleBlock>
            <SingleBlock width="20%">
                <Dropdown
                    options={optionsMetrics}
                    onChange={onMetricChange}
                    value={metric}/>
            </SingleBlock>            
            <SingleBlock width="10%">
                <Section title='Chart Type:'/>
            </SingleBlock>
            <SingleBlock width="30%">
                <Dropdown
                    options={optionsChartType}
                    onChange={onChartTypeChange}
                    value={chartType}/>
            </SingleBlock>
            <HighChart options={options} />
            <Button disabled={!fullData.length || fullData.length === size} label={"Show more"} onClick={() => setSize(size + initialSize)} />
        </Wrapper>
    );
};
